import styled from 'styled-components';
import { paddings } from '~/styled/GlobalStyles';

export const ListItem = styled.li`
  padding: ${() => paddings.defaultPadding};
`;

export { Nav, NavMenu } from '../MobileMenu/styled';
